<svg width="720" height="503" viewBox="0 0 720 503" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M720 395.45C720 613.85 447.523 432 273.179 432C98.8344 432 0 452.951 0 234.55C0 16.1496 229.977 0 404.322 0C578.666 0 720 177.049 720 395.45Z" fill="#36117C"/>
</svg>
